/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Imprint
 */
export interface Imprint {
    /**
     * 
     * @type {string}
     * @memberof Imprint
     */
    text?: string;
}

/**
 * Check if a given object implements the Imprint interface.
 */
export function instanceOfImprint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ImprintFromJSON(json: any): Imprint {
    return ImprintFromJSONTyped(json, false);
}

export function ImprintFromJSONTyped(json: any, ignoreDiscriminator: boolean): Imprint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function ImprintToJSON(value?: Imprint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
    };
}

